module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/btn_2_new_sp_45fdccf4b64014bead8dcfe8c0676d43.png";